// This file was auto-generated by Fern from our API Definition.
export const SimpleTraceChannel = {
    Otlp: "otlp",
    Web: "web",
    Sdk: "sdk",
    Api: "api",
};
